import { getCookieByName } from "../../Helpers/cookieConsent";

interface AbTestingData {
  lastAll: string;
  last1: string;
  last2: string;
  last3: string;
  last4: string;
  last5: string;
}

const validateAbTesting = (abData: AbTestingData): boolean => {
  return !!(
    abData.lastAll !== "" &&
    abData.last1 &&
    abData.last2 &&
    abData.last3 &&
    abData.last4 &&
    abData.last5
  );
};

export const getAbTestingTrackingData = (searchParams: URLSearchParams) => {
  if (typeof window === "undefined") return undefined;

  // Get AB test ID from cookie
  const abTestId = getCookieByName("cvabtest") ?? "";
  const activeTestGroup = searchParams.get("activeTestGroup") ?? "";

  // Get last 5 values
  const lastAll = abTestId.slice(-5);
  const abData = {
    lastAll,
    last1: lastAll[0],
    last2: lastAll[1],
    last3: lastAll[2],
    last4: lastAll[3],
    last5: lastAll[4],
  };

  if (!validateAbTesting(abData)) {
    return undefined;
  }

  // Get active test groups
  const testGroups = activeTestGroup.split(",");
  const activeGroups = {
    hasValue: activeTestGroup !== "",
    isActiveGroup1: testGroups.includes("1"),
    isActiveGroup2: testGroups.includes("2"),
    isActiveGroup3: testGroups.includes("3"),
    isActiveGroup4: testGroups.includes("4"),
    isActiveGroup5: testGroups.includes("5"),
  };

  return {
    abTestingCookie: {
      timestamp: abData.lastAll,
      position1: abData.last1,
      position2: abData.last2,
      position3: abData.last3,
      position4: abData.last4,
      position5: abData.last5,
    },
    activeGroups,
  };
};
